export const lacikonyhaLoginLogoConfig = {
  transform: 'scale(0.6)',
};

export const lacikonyhaAppDrawerLogoConfig = {
  marginTop: '3px',
  marginLeft: '-30px',
  height: '50px',
  transform: 'scale(0.7)',
};

export const lacikonyhaAppDrawerDarkLogoConfig = {
  marginTop: '3px',
  marginLeft: '-30px',
  height: '50px',
  transform: 'scale(0.7)',
};

export const defaultLoginLogoConfig = {
  height: '100px',
};

export const defaultAppDrawerLogoConfig = {
  marginLeft: '20px',
};

export const dreherAppDrawerLogoConfig = {
  marginTop: '-10px',
  marginLeft: '-10px',
  height: '70px',
};
